import { Routines } from '@heidi/design-system/icons';
import {
  AudioLines,
  Brain,
  FileText,
  LayoutTemplate,
  Mail,
  Presentation,
  SquareCheck,
  UserRound,
} from 'lucide-react';
import type { ReactNode, SVGProps } from 'react';

import type { Artifact } from '../../../../data/projects/artifacts/state';
import type { ObjectCreationKind } from '../../../../data/projects/timeline/object-card/object-creation.types';

export type ObjectIconKind = ObjectCreationKind | Artifact['type'];

/**
 * A call signature both Lucide and design-system icons satisfy: `className`/SVG
 * props plus an optional numeric `size`, which is all every caller passes.
 */
export type ObjectKindIconComponent = (
  props: SVGProps<SVGSVGElement> & { size?: number }
) => ReactNode;

const ICONS: Partial<Record<ObjectIconKind, ObjectKindIconComponent>> = {
  session: AudioLines,
  patient: UserRound,
  document: FileText,
  'document-export': FileText,
  'library-document': FileText,
  'form-template': FileText,
  task: SquareCheck,
  tasks: SquareCheck,
  template: LayoutTemplate,
  'template-builder': LayoutTemplate,
  letter: Mail,
  presentation: Presentation,
  workflow: Routines,
  memory: Brain,
};

/** One icon per created-object kind, shared by the transcript card and the panel rows. */
export const objectKindIcon = (kind: ObjectIconKind): ObjectKindIconComponent =>
  ICONS[kind] ?? FileText;
